import { Outlet } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import type { ISignUpFormValues } from './types';

const DEFAULT_VALUES: ISignUpFormValues = {
  firstName: '',
  lastName: '',
  mobileNumber: '',
  officeName: '',
  officeAddress: '',
  officeType: '',
  officeSpecialty: '',
  timePerPatient: { rdh: '', da: '', ddn: '' },
  assistedHygiene: '',
  parkingInfo: { type: '', isFree: '', cost: '', unit: '' },
  softwares: [],
  insurances: [],
  workerType: '',
  psaAccepted: false,
};

export const SignUpLayout = () => {
  const methods = useForm<ISignUpFormValues>({
    mode: 'onSubmit',
    defaultValues: DEFAULT_VALUES,
  });

  return (
    <FormProvider {...methods}>
      <Outlet />
    </FormProvider>
  );
};
